module.exports = {
    __esModule: true,
    default: function anonymous(props
) {
var out='<div class="'+(props.styles.container)+'" data-playable-component> <div class="'+(props.styles.highQualityFrame)+'" data-playable-hook="thumb-high-quality" > </div> <div class="'+(props.styles.lowQualityFrame)+'" data-playable-hook="thumb-low-quality"> </div> <div class="'+(props.styles.thumbText)+'" data-playable-hook="thumb-text-block"> </div></div>';return out;
} 
  };